import React from 'react';
import { Helmet } from "react-helmet";
import { Main } from "../sections/Main/Main";

const Lembawe9 = () => {
    return (
        <>
            <Helmet>
                <title>Lembawe9 - Moroccan Rap Pioneer</title>
                <meta 
                    name="description" 
                    content="Official website of Lembawe9, the influential Moroccan street rap artist. Listen, shop, and connect." 
                />
            </Helmet>
            <main>
                <Main/>
            </main>
        </>
    )
}

export default Lembawe9